import { Box, Chip, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { pillToggleGroupStyles } from "../styles/segmentedControlStyles";
import { KpiStatCard } from "./KpiStatCard";
import {
    KPI_CONTROLS_LABEL_SX,
    KPI_STRIP_ROOT_SX,
    KPI_TILES_SX,
    KPI_TILE_WRAPPER_SX,
    KPI_TOGGLE_WRAPPER_SX,
} from "./kpiCardStyles";

export type KpiAudience = "student" | "parent";

export interface KpiItem {
    id: string;
    label: string;
    value: string | number | null;
    caption?: string;
}

interface KpiStripProps {
    items: KpiItem[];
    loading?: boolean;
    error?: boolean;
    showAudienceToggle?: boolean;
    audience?: KpiAudience;
    onAudienceChange?: (audience: KpiAudience) => void;
    sampleDataNotice?: boolean;
}

export const KpiStrip = ({
    items,
    loading = false,
    error = false,
    showAudienceToggle = false,
    audience,
    onAudienceChange,
    sampleDataNotice = false,
}: KpiStripProps) => {
    const handleAudienceChange = (_event: React.MouseEvent<HTMLElement>, nextAudience: KpiAudience | null) => {
        if (nextAudience) {
            onAudienceChange?.(nextAudience);
        }
    };

    return (
        <Box sx={KPI_STRIP_ROOT_SX}>
            {(showAudienceToggle || sampleDataNotice) && (
                <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, mb: 2 }}>
                    {showAudienceToggle && (
                        <Box sx={KPI_CONTROLS_LABEL_SX}>
                            <Typography variant="body2">View:</Typography>
                            <Box sx={KPI_TOGGLE_WRAPPER_SX}>
                                <ToggleButtonGroup
                                    value={audience}
                                    exclusive
                                    onChange={handleAudienceChange}
                                    size="small"
                                    sx={pillToggleGroupStyles}
                                >
                                    <ToggleButton value="student">Student</ToggleButton>
                                    <ToggleButton value="parent">Parent</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>
                    )}
                    {sampleDataNotice && (
                        <Chip
                            label="Sample data"
                            size="small"
                            color="warning"
                            variant="outlined"
                            sx={{ marginLeft: "auto" }}
                        />
                    )}
                </Box>
            )}
            <Box sx={KPI_TILES_SX}>
                {items.map((item) => (
                    <Box key={item.id} sx={KPI_TILE_WRAPPER_SX}>
                        <KpiStatCard {...item} loading={loading} error={error} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
